import {
  ProductActionTypes,
  REQUEST_PRODUCT_CATEGORIES,
  REQUEST_PRODUCTSV2,
  REQUEST_SPOILAGE_REASONS
} from "./types";
import { Category, Product, ProductSpoilageReason } from "../../models/Product";
import * as ProductApi from "../../api/productApi";
import { isOk } from "../../result";
import * as ProductCategoryApi from "../../api/productCategoryApi";

function fetchProductsV2(products: ReadonlyArray<Product>): ProductActionTypes {
  return {
    type: REQUEST_PRODUCTSV2,
    payload: products
  };
}

function fetchSpoilageReasons(
  spoilageReasons: ReadonlyArray<ProductSpoilageReason>
): ProductActionTypes {
  return {
    type: REQUEST_SPOILAGE_REASONS,
    payload: spoilageReasons
  };
}

function fetchProductCategories(values: Category[]): ProductActionTypes {
  return {
    type: REQUEST_PRODUCT_CATEGORIES,
    payload: values
  };
}

export const thunkFetchProductsV2 = () => async (dispatch: any) => {
  const result = await ProductApi.listV2();

  if (isOk(result)) {
    return dispatch(fetchProductsV2(result.value));
  }

  console.error(result.details);
  return dispatch(fetchProductsV2([]));
};

export const thunkFetchSpoilageReasons = () => async (dispatch: any) => {
  const result = await ProductApi.getSpoilageReasons();

  if (isOk(result)) {
    return dispatch(fetchSpoilageReasons(result.value));
  }

  console.error(result.details);
  return dispatch(fetchSpoilageReasons([]));
};

export const thunkFetchProductCategories = () => async (dispatch: any) => {
  const result = await ProductCategoryApi.getProductCategories();

  if (isOk(result)) {
    return dispatch(fetchProductCategories(result.value));
  }

  console.error(result.details);
  return dispatch(fetchProductCategories([]));
};
